import gql from "graphql-tag";

export default gql`
  query TopCollections($limit: Int = 10) {
    topCollections(limit: $limit) {
      _id
      slug
      name
      contentCounters {
        productsCount
        projectsCount
        storiesCount
      }
    }
  }
`;
